import { createGtm, loadScript } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin(({ vueApp, hooks }): void => {
    const { enabled, id, debug } = useRuntimeConfig().public.gtm
    const route = useRoute()

    vueApp.use(
        createGtm({
            id,
            defer: false,
            compatibility: false,
            enabled,
            debug,
            loadScript: false,
            vueRouter: useRouter(),
            trackOnNextTick: false,
        })
    )

    if (route.query.nogtm) {
        return
    }

    // page:finish runs on every client-side navigation and loadScript has no guard: each call re-inserts gtm.js
    // and pushes another gtm.js event, which re-fires all "All Pages" tags. GTM must be loaded only once.
    hooks.hookOnce('page:finish', () => {
        loadScript(id, {
            defer: true,
            compatibility: true,
        })
    })
})
